module.exports = __webpack_public_path__ + "static/media/bluuu-icon.f67605ef.png";